import React from "react";
import styled from "styled-components";
// Components
import ServiceBox from "../Elements/ServiceBox";
import FullButton from "../Buttons/FullButton";
import { FaCheck, FaUsers } from "react-icons/fa";


export default function Benefits() {
  return (
    <Wrapper id="services" style={{marginTop:'-120px'}}>
   
      <div className="whiteBg" style={{ padding: "60px 0" }}>
        <div className="container">
       
          <ServiceBoxRow className="flex">
            <ServiceBoxWrapper>
              <ServiceBox
                icon='icon'
                title="Virtual Participation"
                subtitle="Busy members or those who are away can engage conveniently without disrupting their schedules or facing penalties"
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="icon"
                title="Borderless Participation"
                subtitle="Geographical boundaries no longer limit your access to financial opportunities. Enjoy the benefits of your group activities regardless of where you reside
                 "
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="icon"
                title="Financial Inclusion"
                subtitle="With low minimum contributions and no collateral requirements, MastaKash enables the participation of the poor, promoting financial inclusivity"
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox icon="icon" title="Fair and Transparent Loan Promotions" 
              subtitle="MastaKash automatically unlocks higher borrowing limits for members as their savings reach the minimum requirements. This ensures fairness and prevents biases in loan distribution" />
            </ServiceBoxWrapper>
          </ServiceBoxRow>


          <ServiceBoxRow className="flex" style={{marginTop:'-120px'}}>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="icon"
                title="Secure and Exclusive Revolving Fund"
                subtitle="MastaKash safeguards group funds, ensuring that it can only be used for the intended  purpose. No one, including officials, can withdraw money from the kitty."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="icon"
                title="Equitable Dividend Distribution"
                subtitle="MastaKash enables equitable distribution of dividends among members based on their shares, saving the group from rankles and conflicts.
                 "
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="icon"
                title="Pride of Ownership "
                subtitle="MastaKash preserves the sense of ownership within the group, allowing members to take pride in their collective achievements"
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox icon="icon" title="Strategic Decision-Making with Data Insights" 
              subtitle="MastaKash generates comprehensive reports and statements, offering valuable insights into the group's performance and opportunities for growth" />
            </ServiceBoxWrapper>
          </ServiceBoxRow>
        </div>

      
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const ServiceBoxRow = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const ServiceBoxWrapper = styled.div`
  width: 20%;
  margin-right: 5%;
  padding: 80px 0;
  @media (max-width: 860px) {
    width: 100%;
    text-align: center;
    padding: 40px 0;
  }
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  margin: 80px 0;
  padding: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 100px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  position: absolute;
  top: -70px;
  right: 0;
  @media (max-width: 860px) {
    width: 80%;
    position: relative;
    order: 1;
    top: -40px;
  }
`;
const AddRightInner = styled.div`
  width: 100%;
`;
const AddImgWrapp1 = styled.div`
  width: 48%;
  margin: 0 6% 10px 6%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp2 = styled.div`
  width: 30%;
  margin: 0 5% 10px 5%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp3 = styled.div`
  width: 20%;
  margin-left: 40%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp4 = styled.div`
  width: 30%;
  margin: 0 5%auto;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;